import { useState } from "react";
import { useDispatch } from "react-redux";

import {
    Box,
    Input,
    Stack,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Avatar,
} from "@mui/material";
import { Add, Edit } from "@mui/icons-material";
import AdminInputs from "./AdminInputs";
import { addAdmin, editAdmin } from "../../features/admin/AdminApi";
import MkButton from "../../app/assets/theme/MkButton";
import { useTheme } from "@mui/material/styles";
import {
    onSelectAdmin,
    removeSelectedAdmin,
} from "../../features/admin/AdminSlice";
import { useSelector } from "react-redux";

export default function EditAdmin({ item }) {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [check, setCheck] = useState(true);
    const [imageData, setImageData] = useState("#");
    const [imageChange, setImageChange] = useState(false);
    const dispatch = useDispatch();
    const { selectedAdmin } = useSelector((state) => state.adminList);

    const handleClickOpen = () => {
        setCheck(true);
        setOpen(true);
        dispatch(onSelectAdmin(item));
    };

    const handleClose = () => {
        setCheck(true);
        setOpen(false);
        setImageChange(false);
        dispatch(removeSelectedAdmin());
    };

    const handleCheck = (e) => {
        setCheck(e.target.checked);
    };

    const imageInputChange = (e) => {
        const [file] = e.target.files;
        if (file) {
            setImageChange(true);
            setImageData(URL.createObjectURL(file));
        }
    };

    const handleAdd = (event) => {
        event.preventDefault();
        const formData = new FormData(event.currentTarget);
        formData.append("active", check ? 1 : 0);
        if (!imageChange) {
            formData.delete("profile");
        }
        dispatch(editAdmin({ data: formData, id: selectedAdmin.id }));
        //close the model box
        setOpen(false);
        dispatch(removeSelectedAdmin());
    };

    return (
        <>
            <MkButton
                mkcolor={`linear-gradient(310deg, ${theme.palette.gradientDark.main}, ${theme.palette.gradientDark.light})`}
                size="small"
                onClick={handleClickOpen}
            >
                Edit
            </MkButton>
            <Dialog
                open={open}
                onClose={handleClose}
                maxWidth="md"
                component="form"
                onSubmit={handleAdd}
            >
                <DialogContent>
                    <Stack
                        direction="row"
                        spacing={1}
                        justifyContent="space-between"
                    >
                        <DialogContentText sx={{ padding: "20px 35px " }}>
                            Edit Admin
                        </DialogContentText>
                        <Box>
                            <label htmlFor="contained-button-file">
                                <Input
                                    accept="image/*"
                                    id="contained-button-file"
                                    type="file"
                                    name="profile"
                                    sx={{
                                        display: "none",
                                    }}
                                    onChange={imageInputChange}
                                />
                                <Avatar
                                    sx={{
                                        width: 70,
                                        height: 70,
                                        cursor: "pointer",
                                    }}
                                    variant="rounded"
                                    src={imageData}
                                />
                            </label>
                        </Box>
                    </Stack>
                    <AdminInputs
                        setImageData={setImageData}
                        handleCheck={handleCheck}
                        checked={check}
                    />
                </DialogContent>
                <DialogActions sx={{ padding: "15px 35px" }}>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button type="submit">Update</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
